import { useMemo } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import { SelectField } from '../SelectField';
import data3dprint from '../../../../config/data3dprint.json';

interface MaterialFieldProps {
  value: number | undefined;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isActive?: boolean;
  isNext?: boolean;
  disabled?: boolean;
  selectedTechnology: string;
  selectedPrinter: number | undefined;
}

export function MaterialField({
  value,
  onChange,
  onFocus,
  onBlur,
  isActive = false,
  isNext = false,
  disabled = false,
  selectedTechnology,
  selectedPrinter
}: MaterialFieldProps) {
  const theme = useTheme(state => state.getThemeStyles());

  const options = useMemo(() => {
    const technology = data3dprint.technologies.find(
      tech => tech.name === selectedTechnology
    );
    
    const printer = technology?.printers.find(
      p => p.id === selectedPrinter
    );

    if (!technology || !printer) return [];

    return printer.materials.map(material => ({
      id: material.id,
      name: material.type,
      label: material.variants.map(variant => variant.name).join(', ')
    }));
  }, [selectedTechnology, selectedPrinter]);

  const isDisabled = disabled || !selectedTechnology || !selectedPrinter;

  return (
    <div className={theme.components.input.variants.select.group}>
      <label 
        htmlFor="material"
        className={`
          ${theme.components.input.variants.select.label.base}
          ${isDisabled ? theme.components.input.variants.select.label.disabled : ''}
        `}
      >
        Material
      </label>
      <SelectField
        name="material"
        label="Material"
        options={options}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        isActive={isActive}
        disabled={isDisabled}
      />
    </div>
  );
} 